import React from 'react';
import { defaultListProps } from '~constants/config';
import { List, TextField, EditButton, DeleteWithConfirmButton, ReferenceField } from 'react-admin';
import CustomDatagrid from '~components/CustomDatagrid';

function SubsectorList({ ...props }) {
  return (
    <List {...defaultListProps} {...props}>
      <CustomDatagrid rowClick="edit">
        <TextField source="id" />
        <TextField source="nameEs" />
        <TextField source="nameEn" />
        <TextField source="namePt" />
        <ReferenceField source="sector" reference="sectores" linkType={false}>
          <TextField source="nameEs" />
        </ReferenceField>
        <DeleteWithConfirmButton label="" />
        <EditButton label="" />
      </CustomDatagrid>
    </List>
  );
}

export default SubsectorList;
